module.exports = __webpack_public_path__ + "img/money.d8e2c6df.png";